<!-- 

	Was macht diese Componente?
	Wofür ist die Compoente da?
	
	Welche $props gibt es?
	
	Beispiel Code:
		<Dummy></Dummy>
	
	2019-06-08	init

-->

<template>
	<div class="CvTable" :class="elmClasses">
		<table class="CvTable__table font font--sizeSmall">
			<thead class="CvTable__thead">
				<tr class="CvTable__tr">
					<th class="CvTable__th" v-for="(cell, i) in app.outputData.headerCols" :key="i">{{cell}}</th>
				</tr>
			</thead>
			<tbody class="CvTable__tbody">
				<tr class="CvTable__tr" :class="{'CvTable__tr--isInvalid' : !row.isValid }" v-for="(row, i) in app.outputData.bodyRows" :key="'tr'+i">
					<td class="CvTable__td" :class="{'CvTable__td--isInvalid' : !cell.isValid }" v-for="(cell, j) in row.cells" :key="'td'+j">{{cell.value}}</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
	// @ is an alias to /src
	//import DevInfos from '@/components/DevInfos.vue'
	import { EventBus } from '@/event-bus.js'

	export default {
		name: 'CvTable',
		components: {},
		mixins: [],
		props: {
			//imageObject: [Object, Boolean],
			//text: [String],
		},
		data() {
			return {}
		},
		watch: {
			someVar: {
				handler: function( to, from ) {
				},
				deep: true,
			}
		},
		computed: {
			app() {
				return this.$root.$children[0]
			},
			elmClasses(){
				let classes = []
				
				//classes.push('new_class')
				
				return classes
			},
			dataSets(){
				return this.app.outputData.bodyRows
			},
		},
		methods: {
			handleScroll(){
				console.log('scrolled')
			}
		},
		created() {
			//window.addEventListener('scroll', this.handleScroll);
		},
		mounted() {},
		destroyed () {
   			//window.removeEventListener('scroll', this.handleScroll);
 		},
	}
</script>

<style lang="less">
	@import "../less/vars.less";
	@import (reference) "../less/mixins.less";
	@import (reference) "../less/atoms.less";
	
	.CvTable {}
	.CvTable__table {
		//outline: 1px solid red;
		min-width: 100%;
		border-collapse: collapse;
	}
	.CvTable__thead {}
	.CvTable__tbody {}
	
	.CvTable__tr {
		vertical-align: top;
		
		&--isInvalid {
			background-color: fade( @swatches[lightRed], 50 );
		}
	}
	
	.CvTable__th,
	.CvTable__td {
		padding: 0.5em;
		border: 1px solid @swatches[grey];
		text-align: left;
	}
	
	.CvTable__th {}
	.CvTable__td {
		&--isInvalid {
			color: @swatches[darkRed];
		}
	}
	
	@media @mediaQueries[xs] {}
	@media @mediaQueries[sm] {}
	@media @mediaQueries[md] {}
	@media @mediaQueries[dt] {}
	@media @mediaQueries[lg] {}
	@media @mediaQueries[xl] {}
</style>
